import { useCallback } from 'react';
import { LedgerActivityReportItem } from '@mews-commander/data-access';
import { TableState } from '@optimus-web/core';
import { notEqual } from '@mews-commander/utils';
import { LedgerActivityReportUrlSearchValues } from '../schema';
import { useNavigateWithFilters } from './useNavigateWithFilters';

interface useTableUrlStateProps {
    tableState: TableState<LedgerActivityReportItem>;
    setTableState: (a: (prev: TableState<LedgerActivityReportItem>) => TableState<LedgerActivityReportItem>) => void;
    filterValues: LedgerActivityReportUrlSearchValues;
}
export const useTableUrlStateChange = ({ tableState, setTableState, filterValues }: useTableUrlStateProps) => {
    const navigateWithFilters = useNavigateWithFilters();
    const handleTableStateChange = useCallback(
        (nextValues) => {
            if (notEqual(nextValues.expanded, tableState.expanded)) {
                setTableState((prev) => ({ ...prev, ...nextValues }));
            }

            const sortChanged = notEqual(nextValues.sort, filterValues.sort);

            if (sortChanged) {
                navigateWithFilters(filterValues, nextValues.sort);
            }
        },
        [navigateWithFilters, filterValues, setTableState, tableState]
    );

    return handleTableStateChange;
};
